// extracted by mini-css-extract-plugin
export default {"div":"Choosers_div__GEtwJ"};